import React, { useEffect, useState } from 'react'
import { Typography } from 'antd'

import { tones } from '../../config/theme'

const { Text } = Typography

const AVATAR_TONES = Object.values(tones)

const getAvatarTone = (id) => AVATAR_TONES[(id || 0) % AVATAR_TONES.length]

const getInitials = (name) => {
  if (!name) return '?'

  const parts = name.trim().split(/\s+/)

  return parts.length > 1
    ? `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
    : parts[0].substring(0, 2).toUpperCase()
}

const UIAvatarLabel = ({ id, name, avatar, icon, square, showName = true, subtitle, tone: toneKey, onAvatarClick }) => {
  const [imgError, setImgError] = useState(false)
  const tone = tones[toneKey] ?? getAvatarTone(id)
  const shapeClass = square ? 'cell-icon-info-icon' : 'cell-icon-info-icon cell-icon-info-icon-round'

  useEffect(() => {
    setImgError(false)
  }, [avatar])

  const image = (
    <img
      src={avatar}
      alt={name}
      className={`${shapeClass} cell-icon-info-avatar-img`}
      onError={() => setImgError(true)}
    />
  )

  return (
    <div className="cell-icon-info">
      {avatar && !imgError ? (
        onAvatarClick
          ? <a className="cell-icon-info-avatar-link" onClick={() => onAvatarClick(avatar)}>{image}</a>
          : image
      ) : (
        <div
          className={shapeClass}
          style={{ backgroundColor: tone.background, color: tone.color }}
        >
          {icon || getInitials(name)}
        </div>
      )}
      {showName && (
        <div className="cell-icon-info-text">
          <Text ellipsis={{ tooltip: name }} className="cell-icon-info-title">{name ?? '-'}</Text>
          {subtitle && <Text type="secondary" ellipsis={{ tooltip: subtitle }} className="cell-icon-info-subtitle">{subtitle}</Text>}
        </div>
      )}
    </div>
  )
}

export default UIAvatarLabel
